<template>
  <b-modal
      id="modalNF"
      ref="modalNF"
      title="Detalhes das Notas Fiscais"
      :visible="visible"
      @hide="resetModal"
      size="lg"
      scrollable
  >
    <b-card>
      <b-card-header>
        <h5>Notas Fiscais</h5>
      </b-card-header>
      <b-card-body>
        <b-table
            :items="notasFiscais"
            :fields="fields"
            striped
            responsive
        >
          <template #cell(visualizar)="data">
            <b-button
                size="sm"
                variant="outline-primary"
                @click="carregarNf(data.item)"
            >
              Visualizar
            </b-button>
          </template>
          <template #cell(show_details)="row">
            <b-form-checkbox
                v-model="row.detailsShowing"
                plain
                class="vs-checkbox-con"
                @change="row.toggleDetails"
            >
          <span class="vs-checkbox">
            <span class="vs-checkbox--check">
              <i class="vs-icon feather icon-check" />
            </span>
          </span>
              <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
            </b-form-checkbox>
          </template>

          <template #row-details="row">

            <b-card>
              <b-row class="mb-2">
               <b-table
                   :items="row.item.itens"
                   :fields="subFields"
                   striped
                   responsive
                />
              </b-row>

              <b-button
                  size="sm"
                  variant="outline-secondary"
                  @click="row.toggleDetails"
              >
                Hide Details
              </b-button>
            </b-card>
          </template>

          <template #cell(avatar)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>

      </b-card-body>
    </b-card>
  </b-modal>
</template>

<script>
import {
  BModal, BCard, BCardHeader, BCardBody, BTable, BButton,
} from 'bootstrap-vue';
import { getTotvsBaseUrl } from '@/utils/totvsApi';

export default {
  components: {
    BModal,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BButton,
  },
  data() {
    return {
      visible: false,
      fields: [
        'Mostrar',
        { key: 'clienteRazaoSocial', label: 'Cliente' },
        { key: 'numeroNota', label: 'Nota Fiscal' },
        { key: 'numeroSerie', label: 'Numero Serie' },
        // { key: 'visualizar', label: 'Visualizar' }
      ],
      subFields: [
        { key: 'itemid', label: 'Código do Produto' },
        { key: 'pedidoitemquantidade', label: 'Quantidade' },
        { key: 'pedidoitemprecotabela', label: 'Preço' },
        { key: 'pedidoitemtotalmercadoria', label: 'Total' },
        // Adicione outros campos se necessário
      ],
      notasFiscais: [],
    };
  },
  methods: {
    showModal(data) {
      this.visible = true;
      this.notasFiscais = data;
    },
    async carregarNf(json) {
      const data = json;
      console.log('data', data.item);

      try {
        // Construct the URL using properties from `data`
        const baseUrl = await getTotvsBaseUrl();
        // const url = `${baseUrl}/gera-danfe/${data.item.estabelecimentoid}/${data.item.numeroNota}/${data.item.numeroSerie}/access_key/AKIA3DOETKBMBNIZXH7A/secret_key/PfyubIh1sCQxjCL+TM99He4eYSSYmPvbsTZRc7Kk/region/sa-east-1`;
        const url = `${baseUrl}/gera-danfe/1/0394761/10/access_key/AKIA3DOETKBMBNIZXH7A/secret_key/PfyubIh1sCQxjCL+TM99He4eYSSYmPvbsTZRc7Kk/region/sa-east-1`;
        // Fetch data from the constructed URL

        const response = await fetch(url);

        // Check if the response is OK
        if (!response.ok) {
          throw new Error(`Erro na solicitação: ${response.statusText}`);
        }

        // Parse the response JSON
        const dataFromResponse = await response.json();

        // Log the response data
        console.log('data', dataFromResponse[0]['c-pArquivo']);
      } catch (error) {
        // Handle any errors
        console.error('Erro ao fazer a solicitação:', error);
      }
    },

    resetModal() {
      this.visible = false;
      this.notasFiscais = [];
    },
  },
};
</script>

<style scoped>
/* Adicione estilos se necessário */
</style>
